module.exports = __webpack_public_path__ + "img/collection-engagementRingsUsa@2x.64e412a.webp";